// Configuración centralizada de la API
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL,
  SERVICES: {
    LOGIN: 'login',
    VERIFY_TOKEN: 'verify_token',
    REGISTER: 'register',
    FORGOT_PASSWORD: 'forgot_password',
  },
  HEADERS: {
    TOKEN: 'X-TOKEN',
    ACCEPT: 'application/json',
    CONTENT_TYPE: 'application/json',
  },
  STORAGE_KEYS: {
    AUTH: 'kt-auth-react-v',
    TOKEN: 'X-TOKEN',
  }
}

// Función helper para construir el body de las requests
export const buildRequestBody = (service: string, additionalParams: Record<string, any> = {}) => {
  return {
    service,
    ...additionalParams,
  }
}

// Función helper para manejar errores de la API
export const handleApiError = (error: any) => {
  if (error.response) {
    // El servidor respondió con un código de estado fuera del rango 2xx
    console.error('API Error:', error.response.data)
    console.error('Status:', error.response.status)
    console.error('Headers:', error.response.headers)
    return error.response.data?.message || 'Error en la respuesta del servidor'
  } else if (error.request) {
    // La petición fue realizada pero no se recibió respuesta
    console.error('Network Error:', error.request)
    return 'Error de conexión. Verifique su conexión a internet.'
  } else {
    // Algo pasó al configurar la petición
    console.error('Error:', error.message)
    return 'Error al procesar la petición'
  }
}
